import { useId } from "react";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import type { IAiScriptExplanationChatThread } from "@/payroll/ai-script/types";
import { ChatThreadListItem } from "./chat-thread-list-item";

interface ChatThreadListProps {
  threads: IAiScriptExplanationChatThread[];
  getIsThreadRunning: (threadId: string) => boolean;
  onOpenThread: (threadId: string) => void;
}

export const ChatThreadList = ({
  threads,
  getIsThreadRunning,
  onOpenThread,
}: ChatThreadListProps) => {
  const labelId = useId();

  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      {/* Rows bleed into the gutter so their text lines up with the label. */}
      <div className="flex min-h-full flex-col px-1.5 py-4">
        {threads.length === 0 ? (
          <Empty
            className={emptyStateVariants({
              layout: "inline",
              className: "px-2.5",
            })}
          >
            <EmptyHeader>
              <EmptyDescription>
                No chats yet for this pay period.
              </EmptyDescription>
            </EmptyHeader>
          </Empty>
        ) : (
          <>
            <p
              id={labelId}
              className="mb-1 px-2.5 text-xs font-medium text-subtle"
            >
              Recent chats
            </p>
            <ul aria-labelledby={labelId} className="flex flex-col">
              {threads.map((thread) => (
                <li key={thread.id}>
                  <ChatThreadListItem
                    thread={thread}
                    isRunning={getIsThreadRunning(thread.id)}
                    onOpen={onOpenThread}
                  />
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
};
